import { render, staticRenderFns } from "./MoleculeEditionBillingMyPaymentsSubMenu.vue?vue&type=template&id=60bbe144&"
import script from "./MoleculeEditionBillingMyPaymentsSubMenu.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionBillingMyPaymentsSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports